import palette from '../theme/palette';

const variants = [
  {
    props: { justifyContent: 'space-between' },
    style: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  {
    props: { color: 'internal' },
    style: {
      background: palette.background.internal,
    },
  },
  {
    props: { disableSpacing: false },
    style: {
      '& > :not(:first-of-type)': {
        // Suppress default space between buttons. Use gap instead.
        marginLeft: 0,
      },
      gap: 10,
    },
  },
];

export default variants;
